module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride3"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph3"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph3"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Little Compton sits on a tiny spit of land on the wrong side of Narragansett Bay. Everything else—Providence, Newport, URI, and civilization—is west. Little Compton is east. It used to be part of Massachusetts, but they didn’t want it and it got handed over to Rhode Island in some obscure Colonial boondoggle back in 1741. The town patriarch was one Colonel Benjamin Church, who led the Colonists’ war against the Wampanoag and slaughtered two hundred of them at the Great Swamp Fight in 1676. A plaque in the square celebrates this historic achievement.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("You don’t come here by accident, or pass through on the way to someplace else. There is nowhere else. The town is a peninsula. The main road narrows, runs along the coast, passes a few scrubby beaches and the tatterdemalion fleet at Dowsy’s Pier, hunkers down into the swamplands of Briggs Marsh, and finally reaches a desolate spot where the only thing around you is gray, sullen ocean. Fog envelops the car. You’re not in Rhode Island anymore, not anywhere, really. Little Compton is a void where the North Atlantic should be.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Our town square is a graveyard. I know how that sounds, but it’s literally true. Look it up on Google Earth and see for yourself. The United Congregational keeps watch on the graves from the top of Commons Street, a view it shares with the post office, elementary school, and community center. You can’t get anywhere in town without passing the cemetery first. It forms the backbone of all local directions.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Here, marked by a Celtic cross with a fouled anchor at its heart, lies my Great-Great Grandpa Ezekiel Hazard, a captain on the Fall River Line ferry to New York. He spent fifty years at sea and drowned in his bathtub after slipping on a bar of Yardley soap. Just to his left is a little granite wedge for Millicent Hazard, 1909-1918, dead of influenza but “")]), _c('span', {
    staticClass: "charoverride5"
  }, [_vm._v("Resting in the Arms of the Lord.")]), _c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("” An imposing obelisk marks the remains of Howland Prosper Hazard, who served one term in the Continental Congress and spent the rest of his life telling the story of how he loaned a half-crown to George Washington for passage on a stagecoach back to Yorktown, where Washington triumphed over the Redcoats. Howland’s epitaph declares him the “")]), _c('span', {
    staticClass: "charoverride5"
  }, [_vm._v("Financier of the Revolution")]), _c('span', {
    staticClass: "charoverride4"
  }, [_vm._v(".”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("And, a few paces away, under a blighted beech tree, rests my mother.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("The only Hazards left now are me and Grandma. My father, not technically dead, read himself out of the family at Thanksgiving a few years ago, which is also where I received the sickle-shaped purple scar on my left shoulder. I didn’t like how it looked so I covered it with a tattooed rose. Then I didn’t like how it made the other shoulder seem bare, so I covered that with a bloody skull. Don’t ask what they mean. I got them out of a book. Dad’s somewhere in Massachusetts; I don’t care to know where.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("\tGrandma’s house is one right and two lefts from the cemetery, on Fillmore Road. In her kitchen is the last pink rotary phone in the world. It even works, though we had to pay the electrician to install an adapter. Now when she turns the wheel it connects to a motherboard inside that translates her analog commands into digital language. It’s like she’s calling from 1974.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Next to the phone is a list of numbers with “Emergency” written on top. I never thought about it until now, but that list is basically her whole life. The first are the pediatrician and vet, both dead, fire department and police. After that comes a different hand, my grandfather’s. It gives the name and number of the electrician, plumber, and a direct line to St. Miriam’s. This was when he found out he had lung cancer.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("The other names are in her handwriting, shaky but recognizable. There are the Laughing Sarahs—more about them later. My number is there, and my father’s. These were numbers she used to remember, but not anymore. The last entry is the saddest. It is her name and phone number. Now the emergency is her.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("The avenues of my grandmother’s mind are closing down, one at a time. Dr. Renzi described it like that: a great city becomes just a town, then a village, then a hamlet, then a single street with a vacant house and broken windows staring blankly. Right now we’re somewhere between the town and the village. But the village still has a telephone, and Grandma’s phone has become the only link to an increasingly shrinking world. Her calls are incessant and strange. Once she interrupted a meeting between me and the department chair to ask why Ronald Reagan stopped making movies.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Because he’s dead,” I answered abruptly. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("There was a long, shocked pause. “My God, has anyone told Nancy?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Another time she dialed AT&T because a zeppelin was trying to dock to her satellite antenna. Then came an endless stream of phantom burglars, mashers, and would-be rapists. The last afternoon Pastor Paige came for coffee, she snuck into the front parlor and called Billy Dyer down at the police station. “He wants to do those sex things again,” she whispered, horrified. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("At the end of the month the bill would come in, full of bizarre notations. Grandma apparently spent three hours on a Thursday afternoon talking with the Office of the Governor General of Canada. Cost: forty-five dollars and eight cents. Calls to a florist in Poughkeepsie, to a charter boat company in Nantucket, to dozens of private numbers whose identities I can only imagine; calls going out in all directions, all day long—distress signals from a foundering liner demanding rescue from anyone near enough to help. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Mine comes on an afternoon in early October. I let it go straight to voicemail. Lately Grandma has taken to calling me every time she mislays something—reading glasses, television remote, keys. I’ve become her Lar, god of the household, even though I haven’t set foot in the place for months. Our dialogue follows a familiar track:")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Did you look on top the television?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Of course I did. What d’you take me for…? Oh.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("But today I’m not in the mood. Back in my little cubbyhole at Faculty Housing, staring at a room that has just ceased to be mine. There is still a tub of peppermint ice cream in the fridge and half a bottle of vodka left over from a welcome-back party weeks ago. It turns out they go well together. So it’s not until evening that I finally pick up the phone and listen to her message.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "charoverride5"
  }, [_vm._v("…gotta come over here and help me, there’s blood everywhere, on the sink and countertop and all over the floor, I don’t know what to do I just found him and I’m sure he’s dead and the lobsters and it looks like his head is—")]), _c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("She cuts off abruptly. There is a rustle and a thump, like she’s dropped the receiver. The next three minutes are static.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Dr. Renzi warned me that her delusions would become more fantastic as the dementia eats away at her sanity. She could become violent or terrified or amorous all in the space of ten minutes, shifting like a one-act tragedian from one scene to the next. “Sooner or later,” he said, “you’re going to have to bring in professional care. The question is not if, but when.” It looks like that moment has come. I call Renzi’s office and leave a message with the triage nurse, requesting an appointment for Maggie Hazard as soon as possible.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Then I call Grandma.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("The phone rings and rings. I imagine it jangling through the house, buzzing the extension in the back parlor, irritating the solemn black Bakelite with its long cloth cord in Grandpa’s old office. But there is no answer. Panicking a little, I ring up Irene, Constance, and Emma—Grandma’s closest friends. No one picks up. I leave a string of increasingly hysterical messages on their answering machines and end up staring at the quad outside my windows, a bare patch of scrubby grass.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("I could call Dad. But I don’t. Not yet. Don’t open that box. Instead, I take out the overnight kit from my desk drawer—kept ready for just such an occasion—and toss it into a rucksack with a spare shirt and a dog-eared copy of Borodin. Five minutes later I’m on Route 95, heading south past the outlets at Wrentham, the monitory spire of the Fleet Bank building, the floodlit capitol with its naked ")]), _c('span', {
    staticClass: "charoverride5"
  }, [_vm._v("Independent Man")]), _c('span', {
    staticClass: "charoverride4"
  }, [_vm._v(" glowering down on the shoppers at Providence Place Mall. Over the Mount Hope Bridge, and into the clinging country dark of Tiverton. I didn’t bother leaving a note. After all, it’s not like anyone will miss me. I’ve just been fired, but that’s a story for another time.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('img', {
    staticClass: "calibre4",
    attrs: {
      "alt": "Image",
      "src": "OEBPS/Images/Break.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph3"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("It is past ten and the house is dark as I approach. Even the porch light is off. Grandma’s place is the biggest on the block, shaped like a foreshortened T. From the road it looks oddly backward, showing its shingled tail to passersby while its white clapboard face stares out to sea. But there is a reason. The house was built on a sloping hill by Captain Ezekiel Barrow in 1704. Its tall windows look out to Narragansett Bay, where Captain Barrow could watch the ships sail in and out of Newport. He even added an extra storey and a widow’s walk with lead-glass windows that opened on a hinge. Old Barrow was a wrecker, and from his lofty perch he watched for ships in distress like a vulture circling carrion. Inside is a patchwork of flotsam from his prizes: a carved Spanish staircase in mission oak with pineapple finials, tall French doors with silver handles, Delft tiles that frame the front room fireplace. Captain Barrow came to a bad end in 1713 when his sloop overturned in a squall as he attempted to claim a prize; his corpse washed up on Breakwater Point. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Gravel and crushed seashells crunch under the tires. The sound usually wakes up anyone within, but not this time. Part of me already imagines the scene I’ll find behind the polished oak door: Grandma sprawled out at the foot of her stairs, neck broken; or slumped over the kitchen table; or tucked into bed like a child with one cold hand resting on the pillow. I’ve seen these visions often enough. When I was young I used to watch her labored breathing as she napped, counting each breath and waiting, terrified, for the rattle and cease. Now it would be a comfort, and I’m angry and ashamed at myself for thinking such thoughts. Nevertheless, even as I move round the house, trying the doors and peering through curtained windows, a cold, clinical part of me is already making lists: call the hospital, the undertaker, her lawyer Mr. Perkins; get out her best black dress with the piecrust collar and seed-pearl piping. Empty the refrigerator. Call the Sarahs.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“David? Is that you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("The sound of her voice makes me jump. Grandma is standing on the back porch, cigarette in hand, wrapped in a green tartan bathrobe that used to be Grandpa’s. The smoke forms a wreath around her head. She looks at me quizzically, but without surprise. “You all right there, kiddo?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Grandma! Are you okay?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Why shouldn’t I be?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“You called me. You sounded really upset. You said…” Here comes the awkward bit. “You said there was a body.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("She raises an eyebrow. “A body? Whose body? What are you talking about, boy?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v(" Honestly, I wish I knew. But the bloody corpse has already flitted back into the Lethe of my grandmother’s imagination. And I’ve just driven all the way from Boston for nothing. “What are you doing outside this time of night?” I ask instead. “It’s freezing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("She shrugs. “I like to watch the waves.” Her cigarette semaphores towards the sea, making a fiery arc. “Want to join me? The ")]), _c('span', {
    staticClass: "charoverride5"
  }, [_vm._v("Dixieland")]), _c('span', {
    staticClass: "charoverride4"
  }, [_vm._v(" oughta be passing by pretty soon.” This is a private joke. The ")]), _c('span', {
    staticClass: "charoverride5"
  }, [_vm._v("Dixieland")]), _c('span', {
    staticClass: "charoverride4"
  }, [_vm._v(" ferry—ludicrously named, filled with day-trippers from New York—passed by our house every day at noon. Sometimes Grandma and I would stand on the bluff, wait until it approached, and then drop skirts and trousers and let our asses hang in the breeze. She chuckles at the memory.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Grandma,” I say again, bringing her back to the present, “you called me. You said something was wrong. Do you remember?” Even as the words leave, I regret them. Her face darkens. She hates to be reminded of “Fuzzy Acres,” as she calls it.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Of course I remember,” she snaps, and we both know she doesn’t. “But I’m fine now. You can go along back up to that college. I don’t want you failing ’cuz of me.” Sometimes she knows I’m an assistant professor now, sometimes not. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“It’s okay. Let’s go inside.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("She shrugs again but doesn’t resist as I take her arm. The house is utterly dark. I wonder how long she’s been standing on the porch. “Did Emma bring dinner yet?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“I think so.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("But the kitchen is cold and untouched. Aunt Emma always rinses the dishes and puts them on the counter—the counter is bare. “Let me fix you something,” I say.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Whose house is this? You sit down. I’ll fix you something.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v(" Before I can protest Grandma puts on the coffee, plugs in the toaster, and pulls out a loaf of bread from the cupboard. While the toast heats she makes scrambled eggs, a perfect yellow disc at the bottom of the pan. This she cuts in two and sprinkles with a dust of salt and castor sugar. At that exact moment the toast pops up. I’ve watched her do this all my life and it still amazes me that she can time it so well. Even the coffee is brewed. Grandma sits across from me and helps herself to eggs. In a moment they’re gone, and most of the toast, too. She eats ravenously, licking her fingers, all delicacy forgotten. I’m beginning to wonder when she ate last.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Did Emma give you your pills tonight?” I can see the little orange bottles still atop the fridge. “Here, I’ll do it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Emma does it,” Grandma corrects, mulishly. “You let her do her job.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Emma is Grandma’s next door neighbor and best friend, but lately Grandma has taken it into her head that she’s some kind of paid housekeeper. I can’t blame her, really. For months now Emma’s come by every night to give Grandma her dinner, pick up the clothes she left strewn on the floor, straighten the furniture, and sort the mail. I’ve learned not to offer her money. Truth is, Emma was always Grandma’s guardian, even before Fuzzy Acres. When Grandpa died it was Emma who chose Grandma’s funeral outfit, dressed her, and fixed her hair while Grandma stared blankly at the mirror, numb with grief. When Grandma started forgetting things—little things, appointments and birthdays and children’s names—it was Emma that kept track. On my birthday I received a Hallmark card with a twenty-dollar bill inside. The card was signed in Grandma’s handwriting but it was addressed in Emma’s. In her own quiet way she gives Grandma the greatest gift any friend ever could, by allowing her to remain herself. But when I tried to express my gratitude, Emma was curt. “Never you mind. You don’t know what she did for me.” Then she changed the subject.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("\tNow I peer out the kitchen windows, over to Emma’s house. Her ancient Buick is parked out front and there is a light on in the kitchen. It’s Thursday night, which means Emma will be watching her shows. Cop dramas mostly, the gorier the better. It’s always been a strange side of her otherwise buttoned-up personality. “Give Em a semi-decomposed corpse in a lonely field,” Aunt Constance likes to say, “and she’s a happy woman.” A flickering blue light reflects on the grass outside her parlor windows. But why hasn’t she come by? ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“I’m gonna go check on Emma,” I say.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Grandma doesn’t look up from her toast. “Tell her those eggs she brought last week were bad. Feathers and blood. Had to throw half away.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Outside the air has a definite chill, and there’s a hint of frost on the lawn. I shiver in my shirtsleeves. Emma’s house is smaller than Grandma’s, a gray saltbox Colonial whose austerity and uncompromising squareness always reminded me of Emma herself. A pot of nasturtiums greets callers at the door. I knock, ring the bell. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "charoverride5"
  }, [_vm._v("My God, what is that? Is that a body?")]), _c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v(" The television blasts away in the front room. Emma has grown rather deaf lately. I try the door and, sure enough, it’s unlocked. It opens right into the parlor, where a rocking chair is pulled up close to the television set. Dr. Ross and Detective Stone peer down at a mangled corpse on the screen. But the chair is empty.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Emma?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "charoverride5"
  }, [_vm._v("Dead some days I expect. There is hypostasis on the lower back and forearms, suggesting")]), _c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("…”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("The inside of the house is small and plain, with only a few stickback chairs in the living room, and a kitchen with a built-in table just behind. A kitchen light with a wicker shade dangles overhead. The light is on, gleaming off a pile of copper pans strewn on the floor. The shelf above the stove is skewed at a cockeyed angle, one plank dangling loosely from a single bent nail.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Emma, you there?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("The kitchen island is one of those old-fashioned stainless-steel models with ceramic sides and a grooved draining board to catch the juices. On the floor behind the island a pair of bare, bluish legs stick out at an odd angle. Fuzzy pink carpet slippers point upward toward the ceiling. Emma’s fingers curl loosely around the handle of a stockpot. The saucepan and braiser lie at her feet. The skillet, polished steel with a weighted iron base, rests gently against her gray curls. A dark smudge on its rim corresponds exactly to the deep wound across her forehead.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Yes,” says a voice behind me, “that’s just how she was when I found her.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Grandma is standing in the doorway holding an unlit cigarette and studying the corpse of her best friend with a dispassionate eye.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“How ")]), _c('span', {
    staticClass: "charoverride5"
  }, [_vm._v("you")]), _c('span', {
    staticClass: "charoverride4"
  }, [_vm._v(" found her?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Sure. Came by a couple hours ago to ask if she had any strawberries, and there she was. Head bashed in something awful.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“But…” My brain is working sluggishly. “But you said it was a man!”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“A man? What man?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“I don’t know! You said it was a man, that there was blood everywhere, something about lobsters…” ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("We both stare as if the other had gone completely insane.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“My God.” I take hold of the kitchen island to steady myself. “Why you didn’t call the police?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“I ")]), _c('span', {
    staticClass: "charoverride5"
  }, [_vm._v("did")]), _c('span', {
    staticClass: "charoverride4"
  }, [_vm._v(". I called them, and Connie and Irene. I called everybody. I called you, David.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Of course. And Irene, Constance, and Billy down at the police station had all reacted just as I had. Which is to say, not at all. “I kept calling and calling,” Grandma goes on, sounding a little peeved, “but nobody answered, so finally I just gave up. What else was I supposed to do?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“But why didn’t you tell me when I got here…? Oh…”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("That look comes back into her eyes, half combative and half terrified. The Revenge of Fuzzy Acres. “I’m sorry, Grandma.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("She shrugs. “Had to happen someday. And this was quick, at least. She prob’ly never felt a thing.” Still, Grandma shudders.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“It’s okay,” I tell her. “I’ll call the police.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v(" “Maybe you’ll have better luck.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Grandma decides this is a good exit line and makes her way back to the house. I’m about to follow when something brushes against my shoe. Something large, dark, and prehistoric is scuttling along the floor, making its laborious bid for freedom.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("A lobster.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('img', {
    staticClass: "calibre4",
    attrs: {
      "alt": "Image",
      "src": "OEBPS/Images/Break.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph3"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Within the hour the police are called, an ambulance ordered, and Grandma is back in her kitchen with a shawl wrapped round her shoulders, a mug of tea in her hand. Aunt Constance remains at Emma’s house, manfully directing the ambulance crew and policemen. Everyone says she is splendid in an emergency. Aunt Irene comes by to keep Grandma company.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Irene is not a small woman, and tonight she has thrown an alpaca shawl over her knitted wool coat and plush pink nightgown. Fabric billows out in all directions. “Ouf!” she cries, collapsing into the chair next to Grandma. “What a night! You all right there, Mags?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Irene,” Grandma answers, looking at her coolly over a raised cup, “what the hell is wrong with you? It’s almost ten. What are you doing here?” She casts a knowing glance. “Has Phil got ‘company’ over again?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Irene, already flushed, gets redder still. “Phil’s dead,” she answers, more brutally than usual. Then she turns to me. “Hey, sweetheart. Sorry you had to deal with all this.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Where’s Emma?” I ask. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Down at Newport General. They’ll keep her till we make other arrangements. I already called Mr. Fuller. He’s up in Tiverton but does all the services at the United Congregational down the road. Very tasteful.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Was she a Congregationalist?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Who knows? It don’t matter, anyhow. There’s only but one big church in town, so they tend to do all the marriages and funerals. Except for the Jews. But there’s only a couple of them, and they go ’cross the bridge to Touro.” She sips her coffee. “I spoke with your dad.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“And?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Her lips form a thin line, which is as close as Irene ever comes to showing displeasure. “He knows you’re here. I guess he’ll see you at the funeral. Probably not before.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Bastard,” I mutter. Grandma doesn’t hear, and Irene pretends not to. I gather up the plates and rinse them in the sink. Irene joins me, and under the sound of the gurgling she leans in. “Sorry! I thought I’d make it here earlier. Was she extra weird?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“No. Almost normal, actually. Seems to be taking it pretty well. Too well, really, for someone who just lost her best friend. She forgot that she found the body, but then when she saw it again it was like—I dunno, like finding a stain on the carpet or something.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Irene nods sagely. “It’s like that with a lot of things now. Doesn’t want to admit she can’t remember, so she fakes it. Poor thing doesn’t even know what emotions she’s supposed to feel. Ah, well, there’s one comfort, I suppose. In a couple hours she won’t remember Emma’s gone. Poor Emma. What a way to go.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“I’m so sorry, Aunt Irene.” And I am. Of all the Aunts, Emma was the most like actual family to me. Neither as smart as Aunt Constance nor as kindly as Aunt Irene, she was somehow more real than either, more solid. She tutored me on geography and physics when Dad was away and Grandma too busy. She let me build a tree house in her yard. “What can I do?” I ask, knowing the answer already.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Well, Constance is handling all the funeral arrangements, and I need to be at the shop…”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("I take a deep breath, let it out slowly. Once the words come they cannot be taken back. “Shall I stay with Grandma for a while?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Oh ")]), _c('span', {
    staticClass: "charoverride5"
  }, [_vm._v("would")]), _c('span', {
    staticClass: "charoverride4"
  }, [_vm._v(" you?” Irene gushes, seemingly surprised by the offer. She spoils the effect by adding, “We’ll make up your room just like it was. It won’t have to be very long. And we never see enough of you, David. Connie was saying just the other day she can’t remember the last time you were down.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("I remember the last time I was down. I suspect Irene does, too. It was when Grandma decided I was a burglar and then, even more disturbingly, that I was Grandpa. We had five minutes of extremely awkward conversation before Aunt Irene intervened and drowned Grandma with ")]), _c('span', {
    staticClass: "charoverride5"
  }, [_vm._v("The Late Show")]), _c('span', {
    staticClass: "charoverride4"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“So tell me,” Aunt Irene leans closer, “can you square it with the college, being gone? Can you take sick leave?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("I realize there’s no point in hiding it from her. The whole story is going to come out anyway. “No,” I answer, as calmly as I can, “they fired me when they found out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "charoverride5"
  }, [_vm._v("What?")]), _c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("” Irene drops her plate into the sink with a clatter. “They can’t do that!”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Sure they can,” Grandma calls from the table. “They do it all the time.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Who?” Irene asks her, curious. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "charoverride5"
  }, [_vm._v("American Bandstand")]), _c('span', {
    staticClass: "charoverride4"
  }, [_vm._v(",” Grandma answers darkly. “Can’t believe a single damned word.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Irene turns back to me and lowers her voice. “How did they find out?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("It’s my turn to shrug. “I had to turn in a prescription form to Benefits. It had my old name on it, and medical history. Somebody asked a question. Supposed to be confidential. Guess it’s not.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Just like that.” She shakes her head. “Frigging Catholics. If only you’d gotten that job in Buffalo…”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Well, now I can go back and ask for it,” I say with a smile. But we both know what’s really coming. Months of unemployment followed by adjunct Hell in some godawful community college. Living from week to week. And no medical, of course, which is going to be damned inconvenient. The shots alone run about a hundred-fifty dollars a pop. But my problems are still a ways off; Grandma’s are right at hand. “What happens…after?” I ask, nodding towards her.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Irene’s hands clench slightly. “It’ll have to be the Methodist Home,” she answers in a whisper. “Connie already called them. There’s a waitlist, but poor Mrs. Everard has stage-four liver cancer so it can’t be long now. A couple months, at most.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“I can stay here till then, if you’d like.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Oh, that’s lovely. We’ll help, of course. I’ll bring over the groceries every Friday night, and Connie’s been handling the household finances…”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“What are you two whispering about?” Grandma demands.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Irene paints a sympathetic smile on her face and turns around. “We were just talking about how we will handle things, now that poor Emma is gone. You’ll miss her, won’t you Maggie, dear?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Miss Emma? Miss Emma?” Grandma’s eyes shift out of focus. She goes on, dreamily, “That’s her problem, of course. Always a miss, never a missus. If only Teddy Johnson had married her…”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Poor Teddy!” Irene responds, recognizing an old cue.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“That would have been different. I always said Emma would be a splendid mother. She has all the right instincts. Too late now, I guess.” This seems a lucid comment, and Irene nods enthusiastically. But then Grandma continues, “She needs to get out more. Can’t stay cooped up in that house all day. If she hung ’round the Boy and Lobster like the other girls do, she’d find someone right enough. Nothing wrong with her looks. And a pretty little sum in the bank, too. A man could go farther and fare worse. How old you suppose she is?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Irene is making frantic semaphores at me, but stupidly I answer, “She was eighty-one.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Grandma scoffs. “Don’t tease. In fact, you seem a likely enough young cub. Got a girlfriend?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“I…no.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Well we’ve got this friend, see. She lives next door. Kinda shy, but you can work past that…”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Maggie,” Irene interjects with forced cheerfulness, can’t you see that’s David? Your grandson?” She says this as if Grandma’s spectacles aren’t strong enough.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Grandson?” Grandma repeats. “No. That’s not right. I never had a grandson.” She looks at me blankly. “You do look familiar, though. But your hair’s too short. And there’s something wrong with your…”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“It’s time for bed.” Irene announces chirpily. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Grandma accepts this and stands up. Irene massages her shoulders. “Need any help getting up the stairs?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Never have, Irene.” She turns looks me up and down. “Let me know if you’d like an introduction. There’s a dance at Pawtuxet next Friday. Everybody’ll be there.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Okay, Grandma,” I answer sadly.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Won’t that be nice?” Irene tweets. She had apparently decided to indulge this fantasy. Perhaps she, too, remembers the Pawtuxet dance. “I’ll wear my Alice Blue chiffon. And you’ve got that sexy black number, Mags, as I recall. What do you suppose Emma will wear?”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“Emma?” Grandma looks scandalized. “What’s the matter with you, Irene? Emma’s dead. She just got walloped with her own pots.”")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("And so to bed.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-240f44d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Chapter_1.vue
// module id = 78
// module chunks = 0